import React, { memo } from "react";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer";
import CourseCard from "./CourseCard";

const CourseList = memo(({ 
  courses = [], 
  type = "qualification", 
  isPast = false,
  loading = false,
  emptyMessage = "No courses available"
}) => {
  
  if (loading) {
    return <SkeletonContainer height={getSkeletonHeight(8)} />;
  }

  if (!courses || courses.length === 0) {
    return (
      <div className="w-100 text-center">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="tab-content" id="pills-tabContent">
      <div className="mycourses-ul-list m-0 d-block">
        <div className="card-grid card-grid--wide">
          {courses.map((course, index) => (
            <CourseCard 
              key={course?.id || index} 
              course={course} 
              type={type} 
              isPast={isPast} 
            />
          ))}
        </div>
      </div>
    </div>
  );
});

export default CourseList;
